<template>
    <div class="reset-password-form">
        <v-form
            @submit.prevent
            v-model="valid"
        >
            <v-container class="ma-0 pa-0">
                <v-row>
                    <v-col
                        cols="12"
                        class="mt-12"
                    >
                        <h2 class="reset-password-title">Сброс пароля</h2>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-10 login-form-text-field"
                                color="#0075AA"
                                label="Введите почту"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="email"
                                :rules="[email_rules]"
                            >
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div
                            class="ml-12 mr-12 mt-n2 d-flex justify-start login-form-error-msg"
                        >
                            {{ msg }}
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div
                            class="ml-12 mr-12 mt-10 mb-12 d-flex justify-space-between"
                        >
                            <div>
                                <v-btn
                                    type="submit"
                                    variant="flat"
                                    color="#0075AA"
                                    height="48"
                                    @click="forgotPassword"
                                >
                                    Сбросить пароль
                                </v-btn>
                            </div>
                            <div
                                class="ml-6 mt-2 login-link"
                                @click="changeForm"
                            >
                                Вернуться
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>
<script>
import { useAuthStore } from '@/store/auth'

export default {
    name: 'ResetPasswordEmailForm',
    data() {
        return {
            email: '',
            msg: '',
            valid: false,
            email_rules: (value) => {
                if (!value) return 'Необходимо ввести почту'
                if (!/.+@.+\.\w{2,4}/.test(value))
                    return 'Недействительная электронная почта'
                return true
            }
        }
    },
    methods: {
        changeForm() {
            this.$emit('changeForm')
        },
        async forgotPassword() {
            const store = useAuthStore()

            await store
                .forgotPassword(this.email)
                .then(() => {
                    alert(
                        'Сообщение с дальнейшими инструкциями было отправлено на указанную почту'
                    )
                })
                .catch(() => {
                    alert(
                        'Что-то пошло не так. Проверьте данные и попробуйте еще раз'
                    )
                })
        }
    }
}
</script>
